<template>
  <Header
    headerShadow="header__area header__padding header__padding-2 header__shadow"
  />
  <section class="page__title-area pt-60 pb-0">
    <div class="container">
      <div class="page__title-content pt-90 mb-0">
        <div class="page__title-breadcrumb">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">{{ $t("actions.home") }}</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/rahbariyat">{{
                  $t("navbar.rahbar")
                }}</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ leaderName }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </section>
  <InstructorDetailsArea class="mt-4" />
  <Footer footerPadding="true" />
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/HomeTwo/Header.vue";
import InstructorDetailsArea from "../components/InstructorDetails/InstructorDetailsArea.vue";
import Footer from "../components/Home/Footer.vue";
import BlogMixin from "../mixins/blogMixin";

export default {
  name: "InstructorDetails",
  mixins: [BlogMixin],
  components: {
    Header,
    InstructorDetailsArea,
    Footer,
  },
  computed: {
    ...mapGetters("leader", ["leaderDetail"]),
    leaderName() {
      return this.getName({
        nameUz: this.leaderDetail?.full_name_uz ?? "",
        nameRu: this.leaderDetail?.full_name_ru ?? "",
        nameEn: this.leaderDetail?.full_name_en ?? "",
      });
    },
  },
};
</script>
